import backend from '@common/backend';

const BASE = '/homeworks';

export const getHomeworks = async (query: any) => backend.get(`${BASE}/`, {
	params: query,
});

export const getHomework = async (id: number) => backend.get(`${BASE}/${id}`);

export const saveHomework = async (id: number, data: any) => backend.put(`${BASE}/${id}`, data);

export const postHomework = async (data: any) => backend.post(`${BASE}`, data);

export const deleteHomework = async (id: number) => backend.delete(`${BASE}/${id}`);
